export enum ImageSize {
  Raw = "",
  Tiny = "/tiny.png",
  Small = "/small.png",
  Medium = "/medium.png",
  Large = "/large.png",
}
